import crypto from 'crypto';
import { getLogger } from '@qwickapps/logging';
const logger = getLogger('QwickForge.Encryption');
const ALGORITHM = 'aes-256-gcm';
const KEY_LENGTH = 32;
const IV_LENGTH = 16;
function getEncryptionKey() {
    const envKey = process.env.ENCRYPTION_KEY;
    if (!envKey) {
        logger.warn('ENCRYPTION_KEY not set - using default key (NOT SECURE FOR PRODUCTION)');
        return crypto.pbkdf2Sync('qwickforge-dev-key', 'salt', 100000, KEY_LENGTH, 'sha256');
    }
    const salt = process.env.ENCRYPTION_SALT || 'qwickforge-salt';
    return crypto.pbkdf2Sync(envKey, salt, 100000, KEY_LENGTH, 'sha256');
}
export function encrypt(plaintext) {
    try {
        const iv = crypto.randomBytes(IV_LENGTH);
        const key = getEncryptionKey();
        const cipher = crypto.createCipheriv(ALGORITHM, key, iv);
        let encrypted = cipher.update(plaintext, 'utf8', 'base64');
        encrypted += cipher.final('base64');
        const authTag = cipher.getAuthTag();
        return [
            iv.toString('base64'),
            authTag.toString('base64'),
            encrypted
        ].join(':');
    }
    catch (error) {
        logger.error('Encryption failed', { error });
        throw new Error('Failed to encrypt data');
    }
}
export function decrypt(encrypted) {
    try {
        const parts = encrypted.split(':');
        if (parts.length !== 3) {
            throw new Error('Invalid encrypted data format');
        }
        const [ivB64, authTagB64, encryptedB64] = parts;
        const iv = Buffer.from(ivB64, 'base64');
        const authTag = Buffer.from(authTagB64, 'base64');
        const key = getEncryptionKey();
        const decipher = crypto.createDecipheriv(ALGORITHM, key, iv);
        decipher.setAuthTag(authTag);
        let decrypted = decipher.update(encryptedB64, 'base64', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    }
    catch (error) {
        logger.error('Decryption failed', { error });
        throw new Error('Failed to decrypt data');
    }
}
export function isEncrypted(value) {
    const parts = value.split(':');
    if (parts.length !== 3) {
        return false;
    }
    const base64Regex = /^[A-Za-z0-9+/]+=*$/;
    return parts.every(part => base64Regex.test(part));
}
export function hash(value) {
    return crypto.createHash('sha256').update(value).digest('hex');
}
//# sourceMappingURL=encryption.js.map